import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout";
import CustomerList from "./components/CustomerList";
import BudgetEntry from "./components/BudgetEntry";
import AuditLog from "./components/AuditLog";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<CustomerList />} />
              <Route path="/budget/:entryId" element={<BudgetEntry />} />
              <Route path="/audit" element={<AuditLog />} />
            </Routes>
          </Layout>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
